import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@utils/constant";

const TableStyle = makeStyles({
  TableWrapper: {
    boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
    backgroundColor: colors.white,
    borderRadius: "6px",
    border: "1px solid #ebeef6",
    "& .MuiBackdrop-root": {
      color: " #fff",
      zIndex: "1201",
    },
  },
  customTable: {
    maxHeight: 680,
    boxShadow: "none",
    "& .MuiTable-root": {
      minWidth: 820,
      tableLayout: "fixed",
      "& .MuiTableCell-root": {
        fontWeight: 500,
        color: colors.black,
        border: "none",
        wordBreak: "break-word",
      },
      "& .MuiTableHead-root": {
        boxShadow: "0 3px 8px 0 rgba(97, 97, 97, 0.08)",
        backgroundColor: colors.white,
        "& .MuiTableCell-root": {
          color: "rgba(33, 33, 33, 0.7)",
          padding: "30px 15px",
          backgroundColor: colors.white,
          borderBottom: "1px solid #f4f4f4",
          "&:first-child": {
            paddingLeft: "30px",
          },
          "&:last-child": {
            paddingRight: "30px",
          },
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableRow-root": {
          "& .dragging, &.dragging *": {
             userSelect: "none !important",
          },
          "& .MuiTableCell-root": {
            padding: 15,
            verticalAlign: "top",
            wordBreak: "break-word",
            "&:first-child": {
              paddingLeft: "30px",
            },
            "&:last-child": {
              paddingRight: "30px",
            },
            "&.order": {
              "& .drag-area": {
                display: "inline-flex",
                alignItems: "center",
                marginRight: 8,
                cursor: "grab",
                paddingTop: 4,
                "&:active": {
                  cursor: "grabbing",
                },
                "& .drag": {
                  color: colors.gray,
                  verticalAlign: "middle",
                  marginLeft: -8,
                  opacity: 0.2,
                  marginTop: -1,
                },
                "& span": {
                  display: "inline-block",
                  verticalAlign: "middle",
                },
              },
            },
            "&.question-text": {
              userSelect: "text",
              paddingTop: 21,
            }
          },
        },
      },
      "& .order": {
        width: 100,
      },
      "& .action": {
        width: 210,
        "& button": {
          minWidth: "auto",
          padding: "6px 7px 7px 7px",
          textTransform: "capitalize",
          border: "1px solid lightgray",
          marginBottom: 5,
          "& .MuiButton-label": {
            justifyContent: "left",
          },
          "& .sub-icon": {
            fontSize: 18,
            verticalAlign: "middle",
            "&.edit": {
              color: colors.orange,
            },
            "&.delete": {
              color: colors.red,
            },  
          },
          "&.editBtn": {
            marginRight: 5,
            "& span": {
              color: colors.orange,
              lineHeight: 1,
              display: "inline-block",
              verticalAlign: "middle",
            }
          },
          "&.deleteBtn": {
            "& span": {
              color: colors.red,
              lineHeight: 1,
              display: "inline-block",
              verticalAlign: "middle",
            }
          },
        },
      },
    },
  },
});

export { TableStyle };
